import { parseNumeric } from '../helpers/number';
import { applyTimezone, parseDate } from './../helpers/date';

export class PayrollPayment {
  id: string;
  companyId: string;
  companyName: string;
  companyCheckingAccount: string;
  receivedFileId: string;
  receivedFileHash: string;
  receivedDate: Date;
  receivedStatus: number;
  receivedStatusDescription: string;
  companyCnpj: string;
  employeeCount: number;
  totalPayrollValue: number;

  constructor(data: PayrollPayment | DjangoPayrollPayment) {
    if (data instanceof PayrollPayment) {
      bindPayrollPayment(this, data);
    } else {
      bindDjangoPayrollPayment(this, data);
    }
  }
}

///////////////////
// DJANGO SUPPOT //
///////////////////

export interface DjangoPayrollPayment {
  id: string;
  company_id: string;
  company_name: string;
  company_checking_account: string;
  received_file_id: string;
  received_file_hash: string;
  received_date: Date;
  received_status: number;
  received_status_description: string;
  company_cnpj: string;
  employee_count: number;
  total_payroll_value: number;
}

function bindPayrollPayment(payrollPayment: PayrollPayment, data: PayrollPayment) {
  payrollPayment.id = data.id;
  payrollPayment.companyId = data.companyId;
  payrollPayment.companyName = data.companyName;
  payrollPayment.companyCheckingAccount = data.companyCheckingAccount;
  payrollPayment.receivedFileId = data.receivedFileId;
  payrollPayment.receivedFileHash = data.receivedFileHash;
  payrollPayment.receivedDate = data.receivedDate;
  payrollPayment.receivedStatus = data.receivedStatus;
  payrollPayment.receivedStatusDescription = data.receivedStatusDescription;
  payrollPayment.companyCnpj = data.companyCnpj;
  payrollPayment.employeeCount = data.employeeCount;
  payrollPayment.totalPayrollValue = data.totalPayrollValue;
}

function bindDjangoPayrollPayment(payrollPayment: PayrollPayment, data: DjangoPayrollPayment) {
  payrollPayment.id = data.id;
  payrollPayment.companyId = data.company_id;
  payrollPayment.companyName = data.company_name;
  payrollPayment.companyCheckingAccount = data.company_checking_account;
  payrollPayment.receivedFileId = data.received_file_id;
  payrollPayment.receivedFileHash = data.received_file_hash;
  payrollPayment.receivedDate = applyTimezone(parseDate(data.received_date), 0);
  payrollPayment.receivedStatus = parseNumeric(data.received_status);
  payrollPayment.receivedStatusDescription = data.received_status_description;
  payrollPayment.companyCnpj = data.company_cnpj;
  payrollPayment.employeeCount = parseNumeric(data.employee_count);
  payrollPayment.totalPayrollValue = parseNumeric(data.total_payroll_value);
}
